import { Action } from "redux";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { getCareType, getDisciplines } from "../../../actions/ServiceRequest";
import ServiceRequest from "../components/serviceRequest/ServiceRequest";
import { DisciplineSearch } from "../../../models/ServiceRequest";

const mapStateToProps = ({
  careTypeState,
  disciplineState,
  TabSessionStorageState,
}: ApplicationState) => ({
  careTypeData: careTypeState,
  disciplineData: disciplineState,
  TabSessionStorageData: TabSessionStorageState,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>) => {
  return {
    getDisciplines: (payload: DisciplineSearch) => {
      dispatch(getDisciplines(payload));
    },

    getCareType: () => {
      dispatch(getCareType());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequest);
